// libraries
import { Root } from '@makemydeal/dr-activities-audit-log';

// consts/enums
import { AUDIT_LOG_ROUTE_ROOT } from '../constants';

const AuditLogRoute = () => {
    return <Root baseRoute={AUDIT_LOG_ROUTE_ROOT} />;
};

export default AuditLogRoute;
